<!--Main Details Menu-->
<div class="val-Grid2ColNormal">
	<label>Application Name:</label>
	<label>{{ logData.ApplicationName }}</label>

	<label>Message Type:</label>
	<label>{{ logData.MessageType }}</label>

	<label>Date and Time:</label>
	<label>{{ logData.DateAndTime }}</label>

	<label>Module:</label>
	<label>{{ logData.ModuleName }}</label>

	<label>Message:</label>
	<textarea disabled class="ld-TextArea" rows="7">{{ logData.Message }}</textarea>

	<label>Logged By:</label>
	<label>{{ logData.LoggedBy }}</label>
</div>

<!--Buttons-->
<div class="val-CenterText val-TopMargin">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
